import orderTypes from '../../json/order_types.json';
import tradeTypes from '../../json/trade_types.json';
import maturityTypes from '../../json/maturity_types.json';

export default {
	orderTypes,
	tradeTypes,
	maturityTypes,
	accountShareBalance: {},
	cashBalance: {
		at_hand: 0.0,
		available: 0.0
	}
};
